import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import type { VuetifyOptions } from 'vuetify'

export const colors = {
  'background': '#F5F5F5',
  'surface': '#FFFFFF',
  'primary': '#F6931E',
  'secondary': '#141312',
  'accent': '#CC0033',
  'highlight': '#F6931E',
  'notify': '#CC0033',
  'success': '#06972E',
  'info': '#F6F6F6',
  'warning': '#F6931E',
  'error': '#CC0033',
  'question': '#141312',
  'cancel': '#787878',
  'upload-new': '#F6931E',
  'upload-paused': '#F6931E',
  'upload-uploading': '#06972E',
  'upload-complete': '#06972E',
  'upload-error': '#CC0033',
  'status-missing': '#787878',
  'status-new': '#428EDA',
  'status-reviewing': '#428EDA',
  'status-approved': '#06972E',
  'status-incomplete': '#CC0033',
  'status-incomplete-can-trade': '#17A68D',
  'status-rejected': '#CC0033',
  'status-none': '#787878',
  'status-unknown': '#312E53',
}
const allColorNames = new Set(Object.keys(colors))
export const config: VuetifyOptions = {
  ssr: true,
  theme: {
    defaultTheme: 'afrimarkets',
    variations: {
      colors: Array.from(allColorNames),
      lighten: 5,
      darken: 5,
    },
    themes: {
      afrimarkets: {
        dark: false,
        colors,
      },
    },
  },
  aliases: {},
  defaults: {
    Swal: {
      backdrop: true,
      color: '#000000',
      background: colors.surface,
      customClass: {
        title: 'text-h6',
        htmlContainer: 'text-body-2',
        popup:
          'v-card v-theme--afrimarkets v-card--density-default v-card--variant-elevated bg-surface elevation-3 pb-3',
        confirmButton:
          'v-btn v-btn--elevated v-theme--afrimarkets bg-primary v-btn--density-default v-btn--size-default v-btn--variant-elevated',
        denyButton:
          'v-btn v-btn--elevated v-theme--afrimarkets bg-error v-btn--density-default v-btn--size-default v-btn--variant-elevated',
        cancelButton:
          'v-btn v-btn--elevated v-theme--afrimarkets bg-cancel v-btn--density-default v-btn--size-default v-btn--variant-elevated',
      },
      confirmButtonColor: colors.primary,
      denyButtonColor: colors.error,
      cancelButtonColor: colors.cancel,
      buttonsStyling: true,
      reverseButtons: true,
    },
    VTextField: {
      variant: 'outlined',
      bgColor: 'surface',
      baseColor: 'surface-darken-4',
      hideDetails: 'auto',
    },
    VSelect: {
      variant: 'outlined',
      bgColor: 'surface',
      baseColor: 'surface-darken-4',
      hideDetails: 'auto',
      itemTitle: 'title',
      itemValue: 'value',
    },
    VAutocomplete: {
      variant: 'outlined',
      bgColor: 'surface',
      baseColor: 'surface-darken-4',
      hideDetails: 'auto',
      itemTitle: 'title',
      itemValue: 'value',
    },
    VSwitch: {
      color: 'primary',
      hideDetails: 'auto',
    },
    VFileInput: {
      variant: 'outlined',
      bgColor: 'surface',
      baseColor: 'surface-darken-4',
      hideDetails: 'auto',
    },
  },
}

export const vuetify = createVuetify(config)
